import LeadModalContract from './LeadModalContract';

export default LeadModalContract;
